import { apiClient } from '@/lib/api.ts'

export function getDealsPhaseMapping() {
  return apiClient.get('/deals/config/phase-mapping')
}

export function getDealsTagsConfig() {
  return apiClient.get('/deals/tanss-tags')
}

export function saveDealsPhaseMapping(mapping: Record<string, number[]>) {
  return apiClient.put('/deals/config/phase-mapping', { mapping })
}
